import { render } from "./PdfReport.vue?vue&type=template&id=ba6e67a8&scoped=true"
import script from "./PdfReport.vue?vue&type=script&lang=js"
export * from "./PdfReport.vue?vue&type=script&lang=js"

import "./PdfReport.vue?vue&type=style&index=0&id=ba6e67a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba6e67a8"]])

export default __exports__